import API from '@/lib/API.js'
import comun from './comun.js'
const internaciones = {
  namespaced: true,
  state: {
    Lista: [],
    ListaPorAfiliado: [],
    ListaPorArea: [],
    Seleccionado: undefined,
    InternacionEnCurso: undefined
  },
  mutations: {
    init(state) {
      state = {
        Lista: [],
        ListaPorAfiliado: [],
        ListaPorArea: [],
        Seleccionado: undefined,
        InternacionEnCurso: undefined,
      }
    },
    set(state, valor) {
      state.Lista = valor
    },
    setPorAfiliado(state, valor) {
      state.ListaPorAfiliado = valor
    },
    setInternacionEnCurso(state, valor) {
      state.InternacionEnCurso = valor
    },
    setPorArea(state, valor) {
      state.ListaPorArea = valor
    },
    setCantidades(state, valor) {
        state.Cantidades = valor
      },
    agregar(state, valor) {
      state.Lista.push(valor)
    },
    select(state, valor) {
      state.Seleccionado = valor
    }
  },
  actions: {
    async traerPorAfiliado({ commit }, valor) {
      let data = []
      data = await API.Internaciones.traerPorAfiliado(valor)
      commit('setPorAfiliado', data)
    },
    async traerPorArea({ commit }, valor) {
      let data = []
      data = await API.Internaciones.traerPorArea(valor)
      commit('setPorArea', data)
    },
    async traerInternacionEnCurso({ commit }, valor) {
      let data = []
      ///trae la autorizacion entera con la internacion
      data = await API.Internaciones.traerinternacionEnCurso(valor)
      commit('setInternacionEnCurso', data)
    },
    select({ commit }, valor) {
      commit('select', valor)
      commit('set', [])
    },
    async modificarSeleccionada({ commit, state }) {
      try {
        let data = []
        let str = ''
        if (state.Seleccionado.id_solic != 0) {
          data = await API.Internaciones.modificar(state.Seleccionado)
          str += 'Internacion modificada'
        } else {
          data = await API.Internaciones.alta(state.Seleccionado)
          commit('agregar', data)
          str += `Internacion dada de alta`
        }
        commit('select', data)
        commit('comun/mostrar', str)
      } catch (error) {
        alert(error)
      }
    },
    async modificarInternacion({ commit, state }, entidad) {
      try {
        let str = ''
        if (entidad.id != 0) {
          entidad = await API.Internaciones.modificar(entidad)
          str += 'Internacion modificada'
        } else {
          entidad = await API.Internaciones.alta(entidad)
          commit('agregar', entidad)
          str += `Internacion dada de alta`
        }
        commit('comun/mostrar', str)
        return entidad
      } catch (error) {
        alert(error)
      }
    }
  },
  modules: {
    comun
  }
}
export default internaciones
